import {observable, makeObservable, runInAction, action} from "mobx";
import CommonStore from "./common_store";
import api from "../../api";
import {message} from "antd";

class HomeStore {
    @observable detailData: any = {};
    @observable detailModalLoading: boolean = false;
    @observable legalPersonIdFront: string = '';
    @observable legalPersonIdBack: string = '';
    @observable businessLicenseImage: string = '';
    @observable bankPermitImage: string = '';
    @observable process: string = '';
    @observable tableDataModal: any = {};
    @observable recordType: number = 0;
    @observable openModal: boolean = false;
    @observable tableLoadModal: boolean = false;
    @observable approvalLoadModal: boolean = false;
    @observable recordDataModal: any = {};
    @observable approvalDataModal: any = {};
    @observable subNodesDataModal: any = [];
    //认证详情分页信息
    @observable recordPageData: IPageData = {
        page: 0,
        size: 10,
        changePage: async (page: number, size: number) => {
            runInAction(() => {
                this.recordPageData.page = page - 1;
                this.recordPageData.size = size;
                this.recordPageData = {...this.recordPageData};
            });
            this.applicationDetails(this.recordType);
        },
    };
    @observable recordModal: any = {
        account: false,
        enterprise: false,
        get isOpen(): boolean {
            return this.account || this.enterprise;
        },
        open: (type: "account" | "enterprise", data: any) => {
            if (type === "account") {
                runInAction(() => {
                    this.recordModal.account = true;
                    this.recordModal.enterprise = false;
                    this.recordType = 2
                    this.applicationDetails(this.recordType);
                });
            } else if (type === "enterprise") {
                runInAction(() => {
                    this.recordModal.account = false;
                    this.recordModal.enterprise = true;
                    this.recordType = 1
                    this.applicationDetails(this.recordType);
                });
            }
        },
        close: () => {
            runInAction(() => {
                this.recordModal.account = false;
                this.recordModal.enterprise = false;
                this.recordDataModal = {};
            });
        },
    };
    @observable approvalModal: any = {
        account: false,
        get isOpen(): boolean {
            return this.account;
        },
        open: (type: "account", data: any) => {
            runInAction(() => {
                this.approvalModal.account = true;
                this.approvalDetails(data.id);
            });
        },
        close: () => {
            runInAction(() => {
                this.approvalModal.account = false;
                this.approvalDataModal = {};
            });
        },
    };
    @observable subNodesModal: any = {
        account: false,
        get isOpen(): boolean {
            return this.account;
        },
        open: (type: "account", data: any) => {
            runInAction(() => {
                this.subNodesModal.account = true;
                this.subNodesDataModal=data?.subNodes
            });
        },
        close: () => {
            runInAction(() => {
                this.subNodesModal.account = false;
                this.subNodesDataModal = {};
            });
        },
    };
    commonStore: CommonStore;

    constructor(baseStore: CommonStore) {
        this.commonStore = baseStore;
        makeObservable(this);
    }

    setProcess(process: string) {
        runInAction(() => {
            this.process = process;
        });
    }

    approvalDetails(id: string | number) {
        runInAction(() => {
            this.approvalDataModal = {};
            this.approvalLoadModal = true;
        });
        api.chooseCompanyApi.approvalList(id).then((res: any) => {
            if (res.code == 200) {
                runInAction(() => {
                    this.approvalDataModal = [...res.data];
                    this.approvalLoadModal = false;
                });
            }
        }).catch((e: any) => {
            console.log(3)
            runInAction(() => {
                this.approvalModal.close()
                this.approvalLoadModal = false;
                this.approvalDataModal={}
            });
        });
    }

    applicationDetails(recordType: any) {
        runInAction(() => {
            this.recordDataModal = {};
            this.tableLoadModal = true;
        });
        const data: any = {};
        data.size = this.recordPageData.size;
        data.page = this.recordPageData.page;
        data.type = recordType;
        api.chooseCompanyApi
            .customerAuthPage(data)
            .then((res: any) => {
                if (res.code == 200) {
                    runInAction(() => {
                        this.recordDataModal = {...res.data};
                        this.tableLoadModal = false;
                    });
                }
            })
            .catch((e: any) => {
                this.recordModal.close()
                runInAction(() => {
                    this.tableLoadModal = false;
                    this.recordDataModal ={}
                });
            });
    }

    @observable detailModal: any = {
        enterprise: false,
        account: false,
        updateModalType: (type: "account" | "enterprise") => {
        },
        get isOpen(): boolean {
            return this.enterprise || this.account;
        },
        open: (type: "enterprise" | "account", data: any) => {
            this.detailModalLoading = true
            if (type === 'enterprise') {
                api.chooseCompanyApi.getDetail(1).then((res: any) => {
                    runInAction(() => {
                        this.detailModal.enterprise = true;
                        this.detailModal.account = false;
                        this.detailData = res.data
                        this.getFileUrl(this.detailData)
                    });
                }).catch((e) => {
                }).finally(() => {
                    this.detailModalLoading = false
                })
            } else if (type === 'account') {
                api.chooseCompanyApi.getDetail(2).then((res: any) => {
                    runInAction(() => {
                        this.detailModal.enterprise = false;
                        this.detailModal.account = true;
                        this.detailData = res.data
                    });
                }).catch((e) => {
                }).finally(() => {
                    this.detailModalLoading = false
                })
            }
        },
        close: () => {
            runInAction(() => {
                this.detailModal.enterprise = false;
                this.detailModal.account = false;
                this.detailData = {};
            });
        },
    };

//获取申请相关文件临时下载地址, 有效期为10分钟
    @action
    async getFileUrl(data: any) {
        if (data.legalPersonIdFront) {
            await api.chooseCompanyApi
                .getFileUrl(data.legalPersonIdFront.objectName)
                .then((res: any) => {
                    runInAction(() => {
                        this.legalPersonIdFront = res.data;
                    });
                })
                .catch((err: any) => {
                });
        }
        if (data.legalPersonIdBack) {
            await api.chooseCompanyApi
                .getFileUrl(data.legalPersonIdBack.objectName)
                .then((res: any) => {
                    runInAction(() => {
                        this.legalPersonIdBack = res.data;
                    });
                })
                .catch((err: any) => {
                });
        }
        if (data.bankPermitImage) {
            await api.chooseCompanyApi
                .getFileUrl(data.bankPermitImage.objectName)
                .then((res: any) => {
                    runInAction(() => {
                        this.bankPermitImage = res.data;
                    });
                })
                .catch((err: any) => {
                });
        }
        if (data.businessLicenseImage) {
            await api.chooseCompanyApi
                .getFileUrl(data.businessLicenseImage.objectName)
                .then((res: any) => {
                    runInAction(() => {
                        this.businessLicenseImage = res.data;
                    });
                })
                .catch((err: any) => {
                });
        }
    }

//下载准入材料文件
    @action
    exportError(objectName: string) {
        api.chooseCompanyApi
            .getFileUrl(objectName)
            .then(async (res: any) => {
                window.open(res.data, '_blank')
                // const link = document.createElement('a')
                // link.download = '错误数据导出.xlsx'
                // link.style.display = 'none'
                // link.href = res.data
                // document.body.appendChild(link)
                // link.click()
                // URL.revokeObjectURL(link.href)
                // document.body.removeChild(link)
            })
            .catch((err: any) => {
            });
    }


}

export default HomeStore;
